import "./src/css/reset.css"
import "./src/css/globalSetting.scss"
import "./src/css/globalStyle.scss"
import "./src/css/animations/globalAnimations.css"